export default __webpack_public_path__ + "static/media/intermx-blue.ea707483.svg";